import { render, staticRenderFns } from "./ExitFullScreen.vue?vue&type=template&id=5115f50a&"
import script from "./ExitFullScreen.vue?vue&type=script&lang=js&"
export * from "./ExitFullScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports